import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class NewsGet extends PlusComponent {
  constructor(props) {
    super(props, "contentNews");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentNews"></ContentSettings>
        </div>
      )
    }
}

export default NewsGet;